// import { useToken } from '@/context/useToken';
// import { ShoppingCart } from 'lucide-react';
// import LoginRequired from '@/components/common/LoginRequired';
import { Separator } from '@/components/ui/separator';
import BackButton from '@/components/common/BackButton';
import Page from '@/components/layout/Page';
import HorizontalLogo from '@/components/common/HorizontalLogo';
import { useCartCookie } from '@/helpers/useCartCookie';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { useCart } from '@/data/cart';
import Loader from '@/components/common/Loader';
import CollapsibleCartItems from './components/CollapsibleCartItems';
import Customer from './components/Customer';
import Payment from './components/Payment';

const CheckoutPage = () => {
  const { getCartId } = useCartCookie();
  const cartId = getCartId();

  // const cart = useCart(cartId);

  return (
    <Page>
      <BackButton />
      <div className="p-8">
        <HorizontalLogo />
      </div>
      <Card>
        <CardHeader>
          <CardTitle>Checkout</CardTitle>
          <CollapsibleCartItems cartId={cartId} />
        </CardHeader>
        <CardContent>
          <Separator className="my-4" />
          <Customer cartId={cartId} />
          <Separator className="my-4" />
          <Payment cartId={cartId} />
        </CardContent>
      </Card>
      <div className="p-12"></div>
    </Page>
  );
};

const CheckoutPageLoader = () => {
  const { getCartId } = useCartCookie();
  const cartId = getCartId();

  const cart = useCart(cartId);

  if (cart.isLoading && !cart.data) {
    return (
      <Page>
        <BackButton />
        <div className="p-8">
          <HorizontalLogo />
        </div>
        <div className="flex justify-center items-center h-[calc(100vh-320px)]">
          <Loader />
        </div>
      </Page>
    );
  }

  return <CheckoutPage />;
};

export default CheckoutPageLoader;
